var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('emb-page-title',{attrs:{"heading":"Blog","subHeading":"","backgroundicon":"/static/images/revised/blog.jpg"}}),_c('v-container',[_c('emb-blog',{attrs:{"secTitle":"Blogs","data":_vm.blogData}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }